import * as React from "react";
import {
  Button,
  createStyles,
  Grid,
  Theme,
  Typography,
  withStyles,
} from "@material-ui/core";
import { Link } from "react-router-dom";

const styles = ({ spacing }: Theme) =>
  createStyles({
    buttonWrapper: {
      backgroundColor: "#00cc00",
      marginTop: spacing(1),
    },
  });

class AdminSection extends React.Component<any> {
  constructor(props: any) {
    super(props);
  }

  public render() {
    return (
      <div style={{ flexGrow: 1 }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Grid container spacing={3} justify="center">
              <Grid item xs>
                <Typography align="center">
                  <Button
                    variant="outlined"
                    component={Link}
                    to="/add-drug"
                    color="default"
                    style={{ width: 225 }}
                  >
                    Add Drug
                  </Button>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(AdminSection);
